<template>
  <b-container fluid
               class="embed"
               :class="{'compact':hasAddress}">
    

    <EmbedSearch></EmbedSearch>

  </b-container>
</template>

<script>
import EmbedSearch from "@/views/EmbedSearch.vue"

export default {
  name: "Embed",
  components: {
    EmbedSearch
  },

  data() {
    return {}
  },
  watch: {
    isPreloaded(newVal) {
      if (newVal) {
        this.$store.dispatch("initialize");
      }
    }
  },
  mounted() {
    // Initialize if already preloaded, otherwise wait for watch
    if (this.isPreloaded) {
      this.$store.dispatch("initialize");
    }
  },
  methods: {}
};
</script>
<style scoped lang="scss">
.embed {
  display: grid;
  background: white;
  max-height: 500px;
  align-items: start;
  align-content: start;

}
</style>
